<script lang="ts">
  import clsx from 'clsx';
  import type { PageProps } from './types';

  const { children, footer, class: className, reloadOnNavigate }: PageProps = $props();
</script>

<div
  class={clsx(className, 'flex min-h-screen flex-col')}
  {...reloadOnNavigate ? { 'data-sveltekit-reload': true } : {}}
>
  <div class="flex grow flex-col">
    {@render children()}
  </div>
  {#if footer}
    <div>
      {@render footer()}
    </div>
  {/if}
</div>
